const PLAN_SELECTION_KEY = 'asi:selected-plan';

function isBrowser() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function setSelectedPlanId(planId) {
  if (!isBrowser()) {
    return;
  }
  if (!planId) {
    window.localStorage.removeItem(PLAN_SELECTION_KEY);
    return;
  }
  window.localStorage.setItem(PLAN_SELECTION_KEY, String(planId));
}

export function consumeSelectedPlanId() {
  if (!isBrowser()) {
    return null;
  }
  const planId = window.localStorage.getItem(PLAN_SELECTION_KEY);
  if (planId) {
    window.localStorage.removeItem(PLAN_SELECTION_KEY);
  }
  return planId || null;
}
